import * as React from 'react'
import { Button, Popover, makeStyles, Tab, Box, Tabs } from '@material-ui/core'
import Debug from './Debug'
import DebugMenu from './DebugMenu'

const useStyles = makeStyles({
    root: {
        backgroundImage: 'linear-gradient( 109.6deg,  rgba(209,0,116,1) 11.2%, rgba(110,44,107,1) 91.1% )',
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '1rem',
    },
    close: {
        position: 'fixed',
        zIndex: '100',
        right: '50px'
    },
    wrapper: {
        padding: '1rem',
    },
    popover: {
        backgroundColor: 'rgba(68,68,68,0.3)'
    }
})

const tabs = [
    {
        label: "Profils",
        Component: <Debug />
    },
    {
        label: "Customisation",
        Component: <DebugMenu />
    }
];

const DebugWrapper = () => {
    const styles = useStyles()
    const [anchorEl, setAnchorEl] = React.useState(undefined)
    const [open, setOpen] = React.useState(false)

    const openClick = (e) => {
        setAnchorEl(e.currentTarget)
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false);
    }

    const [tabValue, setValue] = React.useState(0);
    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={styles.root}>
            <Button variant="contained" color="primary" onClick={openClick}>
                Student context
            </Button>
            <Popover
                open={open}
                anchorEl={anchorEl}
                className={styles.popover}
                onClose={handleClose}
            >
                <div className={styles.wrapper}>
                    <Button variant="contained" className={styles.close} onClick={() => setOpen(false)}>
                        Close
                    </Button>
                    <Box sx={{ width: '50dvw', position: 'relative' }}>
                        <Box sx={{ borderBottom: 1, borderColor: "divider", position: 'sticky', top: 0, background: 'white', padding: '10px', zIndex: 10 }}>
                            <Tabs
                              value={tabValue}
                              onChange={handleTabChange}
                              aria-label="basic tabs example"
                            >
                                {tabs.map(({ label }, i) => (
                                  <Tab label={label} key={i} />
                                ))}
                            </Tabs>
                        </Box>
                        {tabs.map(({ Component }, i) => (
                          <div
                            key={i}
                            role="tabpanel"
                            hidden={tabValue !== i}
                            id={`simple-tabpanel-${i}`}
                            aria-labelledby={`simple-tab-${i}`}
                          >
                              {Component}
                          </div>
                        ))}
                    </Box>
                </div>
            </Popover>
        </div>
    )
}

export default DebugWrapper
